<template>
  <div class="wrapper" style="position: relative;">
    <div class="name-text" @click="onClickNameLink">{{ displayName }}</div>
    <div class="meta-line">
      <span>{{ displayCompany }}</span>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
export default {
  name: "CellRendererCrewInfo",
  mixins: [ColorMixin],
  computed: {
    displayName() {
      return this.params.value.name;
    },
    displayCompany() {
      return this.params.value.company;
    },
  },
  methods: {
    onClickNameLink() {
      this.params.onClickNameLink(this.params.value.id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

.wrapper {
  display: flex;
  flex-direction: column;
  gap: 2px;

  .name-text {
    color: $aisea-blue;
    cursor: pointer;
    font-family: $aisea-font-family;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    text-decoration: underline;
    text-align: left;
  }

  .meta-line {
    display: flex;
    gap: 4px;
    color: $aisea-gray-black;
    font-family: $aisea-font-family;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
  }
}
</style>
